import React, { useEffect, useState } from "react";
import PublicLayout from "@/components/PublicLayout";
import { api } from "@/lib/api";
import { ROLE_LABEL } from "@/lib/utils-cart";

export default function Guides() {
  const [guides, setGuides] = useState([]);
  const [role, setRole] = useState("supplier");
  useEffect(() => { api.get(`/guides?role=${role}`).then((r) => setGuides(r.data)); }, [role]);

  const roles = ["supplier", "merchant", "affiliate", "creator", "fulfillment_partner", "service_provider"];

  return (
    <PublicLayout>
      <section className="border-b border-border bg-card">
        <div className="max-w-6xl mx-auto px-6 py-12">
          <div className="label-eyebrow text-secondary mb-2">Role guides</div>
          <h1 className="font-display text-4xl md:text-5xl font-black tracking-tighter text-primary leading-none">How to win on Vendora.</h1>
          <p className="mt-4 text-muted-foreground">Pick your role to see step-by-step playbooks.</p>
          <div className="mt-6 flex flex-wrap gap-2">
            {roles.map((r) => (
              <button key={r} onClick={() => setRole(r)} className={`v-btn-outline ${role === r ? "border-primary bg-primary text-white" : ""}`} data-testid={`guides-role-${r}`}>
                {ROLE_LABEL[r]}
              </button>
            ))}
          </div>
        </div>
      </section>
      <section className="max-w-4xl mx-auto px-6 py-10 space-y-3">
        {guides.map((g, i) => (
          <div key={g.id} className="v-card">
            <div className="font-mono text-xs text-muted-foreground">Chapter {i + 1}</div>
            <h2 className="font-display text-2xl font-bold text-primary mt-1">{g.title}</h2>
            <p className="mt-3 text-muted-foreground leading-relaxed">{g.body}</p>
          </div>
        ))}
        {guides.length === 0 && <div className="text-center text-muted-foreground py-10">No guides for this role yet.</div>}
      </section>
    </PublicLayout>
  );
}
